<template>
    <section>
        <v-data-table :headers="headers" 
                      :items="GetCourseList" 
                      :pagination.sync="pagination" 
                      hide-actions
                      disable-initial-sort
                      select-all item-key="Course_Title" class="elevation-1">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="SortColumn(header.value)">
                    <v-icon small>arrow_upward</v-icon> {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                    <td class="text-xs-center">{{ props.item.FAQs.length }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="OpenUpdateFAQModal(props.item,'Update')">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn color="error" icon class="btnAction" @click="OpenUpdateFAQModal(props.item,'Delete')">
                            <v-icon>delete</v-icon>
                        </v-btn>
                        <!-- <v-icon  color='error' @click="DeleteCourseFAQ(props.item)">delete_sweep</v-icon> -->
                    </td>
                </tr>
            </template>
        </v-data-table>
        <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
        <app-update-faq ref="UpdateSection" :dialog="UpdateFAQ" @close='CloseDialog'></app-update-faq>
    </section>
</template>
<script>

import appUpdateCurriculam  from '../dialogs/UpdateCurriculam'
import appUpdateFaq         from '../dialogs/AddFAQs'

export default {
    components: {
        appUpdateCurriculam,
        appUpdateFaq
    },
    data(){

        return {

            pagination       : { sortBy: 'Course_Title'},
            headers          : [ { text: 'Course Title',value: 'Course_Title' },
                                 { text: 'No Of FAQs' },
                                 { text: 'Actions' } ],
            UpdateFAQ        : false,
            loading          : false,
            pages            : 1,
            records          : 0,  
        }
    },
    computed:{
        GetCourseList(){

            return this.$store.getters.GetCourseFAQsList
        }
    },
    methods:{
        SortColumn (column) {

            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
      },
      OpenUpdateFAQModal(Course,Type){
        if( type == 'edit' || (type == 'delete' && confirm("Do you really want to delete?"))){
            this.UpdateFAQ  = true
            this.$refs.UpdateSection.GetFAQs(Course,Type)
        }
      },
      CloseDialog(){

          this.UpdateFAQ    = false
      },
      GetNextSetOfData(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/courseFAQs/getcourseFAQs`,{ limit:10, page : this.pages })
                    .then(response =>{
                        
                        this.$store.commit('SetCourseFAQsList',response["data"]["response"])
                        this.records = response["data"]["Records"]

                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })

      },
      DeleteCourseFAQ(Course){

        let FAQ = {}
        FAQ['Course_Id'] = Course['Course_Id']
        this.$http.post(`${this.$store.getters.GetProductionUrl}/courseFAQs/deletecompletecourse`,FAQ)
                    .then(response =>{
                        
                        this.$store.commit('DeleteIndividualCourseFAQs',response["data"]["response"])
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated FAQ","Color":"green","Close": false });
                        this.ClearForm()
                        this.CloseDialog()
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating FAQ","Color":"red","Close": false });
                    })
      }
    },
    mounted(){

        this.GetNextSetOfData()
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
</style>


